import Link from '@components/common/Link/Link'

import { getProductName } from '@components/views/Product/helpersv2'
import { formatPriceV2 } from '@lib/format-price'
import { ProductGridTileFragment } from '@lib/graphql/graphql'
import { MediaWithCropsFragment } from '@lib/umbraco/generated/types.generated'
import { generateMediaUrlV2 } from '@lib/utils'
import {
  selectAlpha2Code,
  selectCountry,
  selectLabels,
} from '@redux/globalSlice'
import { useAppDispatch } from '@redux/store'
import { addItem, removeItem, selectWishlist } from '@redux/wishlistSlice'
import { mapEdgesToItems } from '@utils/map'
import clsx from 'clsx'
import { FC, useMemo } from 'react'
import { useSelector } from 'react-redux'
import Heart from '../Icons/Heart/Heart'
import ProductCartTag from '../Icons/ProductCartTag/ProductCartTag'
import Media from '../Media/Media'
import s from './ProductCard.module.scss'
export interface ProductCardProps {
  product: ProductGridTileFragment
  tileColor?: 'dark' | 'light'
  lcp?: boolean
}

type ProductTag = {
  label: string
  labelColor?: string
  fill?: string
}
const ProductCard: FC<ProductCardProps> = ({ product, tileColor, lcp }) => {
  const productName = useMemo(() => getProductName(product.name), [product])
  const dispatch = useAppDispatch()
  const wishList = useSelector(selectWishlist)
  const country = useSelector(selectCountry)
  const alpha2Code = useSelector(selectAlpha2Code)

  const labels = useSelector(selectLabels)
  const imagePadding = product.heroVariant?.metadata?.some(
    (x) => x.key !== 'DISABLE_IMAGE_PADDING',
  )
  const applyForceDisplayLogic = country.code === 'US'

  // const forceFullPrice = useMemo(
  //   () =>
  //     applyForceDisplayLogic &&
  //     (product.heroVariant.stockAvailability?.state == 'OUT_OF_STOCK' ||
  //       (product.heroVariant.stockAvailability?.state == 'IN_STOCK' &&
  //         product.heroVariant.stockAvailability?.quantity == 0)),
  //   [product.heroVariant],
  // )

  // const discountDisplay = useMemo(() => {
  //   let hasDifferentDiscountsOnVariants = false
  //   let hasDiscount = false

  //   let highestDiscountPercentage = 0
  //   let lowestDiscountPercentage = 0
  //   if (product?.variants?.length > 0) {
  //     product?.variants?.forEach((variant) => {
  //       if (variant?.discountedPrice?.percentageOff > 0) {
  //         hasDiscount = true
  //         if (
  //           variant?.discountedPrice?.percentageOff > highestDiscountPercentage
  //         ) {
  //           if (
  //             highestDiscountPercentage > 0 &&
  //             highestDiscountPercentage != 0
  //           ) {
  //             hasDifferentDiscountsOnVariants = true
  //           }
  //           highestDiscountPercentage = variant?.discountedPrice?.percentageOff
  //         }
  //         if (
  //           variant?.discountedPrice?.percentageOff < lowestDiscountPercentage
  //         ) {
  //           lowestDiscountPercentage = variant?.discountedPrice?.percentageOff
  //         }
  //       }
  //     })
  //   } else if (product.heroVariant?.discountedPrice?.percentageOff > 0) {
  //     hasDiscount = true
  //     highestDiscountPercentage =
  //       product.heroVariant?.discountedPrice?.percentageOff
  //   }

  //   if (forceFullPrice) hasDiscount = false

  //   return {
  //     hasDifferentDiscountsOnVariants,
  //     hasDiscount,
  //     highestDiscountPercentage,
  //     lowestDiscountPercentage,
  //   }
  // }, [product, forceFullPrice])

  const productTags = useMemo(() => {
    const tags: ProductTag[] = []

    // if (
    //   discountDisplay.hasDiscount &&
    //   product.heroVariant.discountedPrice?.value
    // ) {
    //   tags.push({
    //     label: `${
    //       discountDisplay.hasDifferentDiscountsOnVariants ? 'up to' : ''
    //     } ${discountDisplay.highestDiscountPercentage}%`,
    //     fill: 'var(--discount-red)',
    //     labelColor: 'rgb(255, 255, 255)',
    //   })
    // }
    const discountedPrice = product.heroVariant?.price?.discountedPrice

    if (
      discountedPrice &&
      discountedPrice?.discount.value.__typename ===
        'ProductDiscountRelativeValue'
    ) {
      tags.push({
        label: `${discountedPrice?.discount.value?.factor * 100}%`,
        fill: 'var(--discount-red)',
        labelColor: 'rgb(255, 255, 255)',
      })
    }

    if (product.tags.find((tag) => tag === 'label_Responsible')) {
      tags.push({
        label: 'Responsible',
        fill: 'rgb(0,128,0)',
        labelColor: 'rgb(255, 255, 255)',
      })
    }

    // if (product.heroVariant?.availability?.availableQuantity > 0) {
    // if (
    //   product.availableShippingMethods?.find((x) => x.price.centAmount === 0)
    // ) {
    //   tags.push({
    //     label: 'Free Shipping',
    //   })
    // } else {
    //   tags.push({
    //     label: 'Fast Shipping',
    //   })
    // }
    // }

    if (product.tags?.find((tag) => tag === 'msgtype_New')) {
      tags.push({
        label: (labels.labelMsgTypeNew.find((x) => x) as any).labelName,
      })
    }

    //slice the array because it can max show 2 tags
    return tags.slice(0, 2)
  }, [
    product,
    // discountDisplay
  ])

  if (!product.heroVariant) {
    return null
  }
  const isFilled = !!wishList.includes(product.heroVariant.id)
  const media = mapEdgesToItems(product.heroVariant.media)

  const hoverImage =
    media?.find((image) => image?.fileName?.split('_')[1] === 'L') ??
    media?.find((image) => image?.fileName?.split('_')[1] === 'C')

  return (
    <li className={s.root}>
      <div className={s.imageWrapper}>
        <button
          type="button"
          className={s.wishlistIcon}
          aria-label={isFilled ? 'Remove from wish list' : 'Add to wish list'}
          title={isFilled ? 'Remove from wish list' : 'Add to wish list'}
          onClick={(e) => {
            isFilled
              ? dispatch(removeItem(product.heroVariant.id))
              : dispatch(addItem(product.heroVariant.id))

            e.preventDefault()
          }}
        >
          <Heart color="black" width={24} height={24} filled={isFilled} />
        </button>
        <Link
          link={{ url: `/products/${product.slug}` }}
          query={{
            itemNumber: product.heroVariant.sku,
          }}
          className={s.link}
        >
          <ul className={s.tagsContainer}>
            {productTags.map((tag, index) => (
              <li key={index} className={s.tagItem}>
                <ProductCartTag
                  fill={tag.fill}
                  label={tag.label}
                  labelColor={tag.labelColor}
                />
              </li>
            ))}
          </ul>
          <Media
            mediaWithCrops={
              {
                url: generateMediaUrlV2(media[0]?.src),
                media: {
                  __typename: 'Image',
                  url: generateMediaUrlV2(media[0]?.src),
                },
              } as MediaWithCropsFragment
            }
            className={clsx(s.imageContainer, {
              [s.darkTile]: tileColor === 'dark',
            })}
            mediaClassName={clsx(s.image, {
              [s.padded]: imagePadding,
            })}
            priority={lcp}
            sizes="(max-width: 834px) 50vw, 20vw"
            scaleOnHover
            disableShopTheLook
          />
          {hoverImage && (
            <Media
              mediaWithCrops={
                {
                  url: generateMediaUrlV2(hoverImage.src),
                  media: {
                    __typename: 'Image',
                    url: generateMediaUrlV2(hoverImage.src),
                  },
                } as MediaWithCropsFragment
              }
              className={clsx(s.imageContainer, s.hoverImageContainer)}
              mediaClassName={clsx(s.image, s.hoverImage)}
              disableShopTheLook
              sizes="(max-width: 834px) 50vw, 20vw"
            />
          )}
        </Link>
        {product?.variantsCount > 1 && (
          <div className={s.colorsContainer}>
            <span className={s.bold}>{product?.variantsCount} variants </span>
            <span>available</span>
          </div>
        )}
      </div>
      <Link link={{ url: `/products/${product.slug}` }} className={s.link}>
        <div className={s.productDetails}>
          <div className={s.productDetailsDescription}>
            <h2 className={s.productName}>{productName?.name}</h2>
            <span className={s.productSecondaryName}>
              {productName?.secondaryName}
            </span>
          </div>
          <div className={s.priceWrapper}>
            {product.heroVariant.price?.discountedPrice && (
              <span className={s.discountedPrice}>
                {formatPriceV2(
                  alpha2Code,
                  product.heroVariant.price.discountedPrice?.value,
                  2,
                )}
              </span>
            )}

            <span
              className={clsx(s.originalPrice, {
                [s.strikethrough]: !!product.heroVariant.price?.discountedPrice,
              })}
            >
              {product.heroVariant.price &&
                formatPriceV2(alpha2Code, product.heroVariant.price.value)}
            </span>
          </div>
        </div>
      </Link>
    </li>
  )
}

export default ProductCard
